import { Contact } from '@eigtech/contacts-types'
import { useAuth0 } from '@eigtech/ui-shared-auth'
import { useGetContacts } from '@eigtech/ui-shared-contacts'
import { useMemo } from 'react'
import { useGetDelegateUser } from './getDelegateUser'

export function useGetDelegateUserContacts() {
  const { user } = useAuth0()

  const delegateQuery = useGetDelegateUser({ auth0Id: user?.sub ?? '', email: user?.email ?? '' })

  return useGetContacts(delegateQuery.data?.map((e) => e?.externalUserId ?? '') ?? [])
}

export function useGetDelegateUserActiveContacts() {
  const contactsQueries = useGetDelegateUserContacts()

  const { isContactsError, isContactsLoaded, isContactsPending, contacts, contactIds } =
    useMemo(() => {
      const contacts = contactsQueries
        .map(({ data }) => data)
        .filter((data): data is Contact => !!data && !data.metadata.removed)
      const contactIds = contacts.map((c) => c.contactId)
      const isContactsError = contactsQueries.some((cq) => cq.isError)
      const isContactsPending = contactsQueries.some((cq) => cq.isPending)
      const isContactsLoaded = contactsQueries.every((cq) => !!cq.data)
      return { contacts, contactIds, isContactsError, isContactsLoaded, isContactsPending }
    }, [contactsQueries])

  return {
    contacts,
    contactIds,
    isContactsError,
    isContactsLoaded,
    isContactsPending,
    queries: contactsQueries,
  }
}
